import * as _ from "lodash";
import * as $ from "jquery";
import * as moment from "moment-timezone";
import {UserGroupCollection} from "../../../collections/UserGroups";
import {UserCollection} from "../../../collections/Users";
import {DashboardNotificationCollection} from "../../../collections/DashboardNotifications";
import {BaseList, TableProperties} from "../../_BaseList";
import * as Backbone from "backbone";
import {InstallCollection} from "../../../collections/Installs";
import {PermissionCollection} from "../../../collections/Permissions";
import {DashboardChannelCollection} from "../../../collections/DashboardChannels";
import {BaseCollection} from "../../../collections/_BaseCollection";
import {ModuleCollection} from "../../../collections/Modules";
import {BaseDetailAccountView, BaseDetailAccountViewOptions} from "../_BaseAccountViews";


export interface DashboardDetailViewOptions extends BaseDetailAccountViewOptions {
    currentDashboard: Backbone.Model;
    groupPermissionCollections: { [groupId: number]: PermissionCollection };
    dashboardChannelCollection: DashboardChannelCollection;
}

abstract class BaseDashboardDetailView extends BaseDetailAccountView {
    options: DashboardDetailViewOptions;

    constructor(options: DashboardDetailViewOptions) {
        super(options);
    }
}

export class DashboardTeamView extends BaseDashboardDetailView {

    constructor(options: DashboardDetailViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'click .add-user-team-button': 'handleCreateUserButtonClick',
                'click .delete-from-list': 'handleDeleteUserGroupUser',
            }
        }));
    }

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/dashboards/' +
            this.options.currentDashboard.get('id') + '/teams';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Teams with access to this Dashboard', url: this.options.isOverview ? url : null},
            panelClass: 'teams',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            if (!this.options.groupPermissionCollections[id]) {
                this.options.groupPermissionCollections[id] = new PermissionCollection([], {userGroupId: id});
            }
            return this.options.groupPermissionCollections[id].getCollectionFetchPromise();
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var teamTable = new BaseList(this.options);
        var teamTableProperties: TableProperties;
        teamTableProperties = {
            tableEmptyText: 'There are no Teams with access',
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/teams/',
            columnProperties: {
                'Team Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '5',
                        'md': '5',
                        'xs': '12'
                    }
                },
                'Permissions': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var perms = []; %>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canViewDashboard(dashboardId)) perms.push("View")%>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canModifyDashboard(dashboardId)) perms.push("Modify") %>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canDeleteDashboard(dashboardId)) perms.push("Delete") %>' +
                            ' <div class="col-md-6 col-sm-6 col-xs-10">' +
                            '<% if(perms.length) { %>' +
                            '<%- perms.join(", ") %>' +
                            '<% } else { %>' +
                            '<%- "None" %>' +
                            '<% }  %>' +
                            ' </div>'),
                        variables: {
                            groupPermissionCollections: this.options.groupPermissionCollections,
                            dashboardId: Number(this.options.currentDashboard.get('id')),
                        }
                    },
                    columnSizes: {
                        'sm': '6',
                        'md': '6',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            teamTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'is_admin',
                reverseSort: true,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }
        var teams = this.options.userGroupCollection.filter((team) => {
            return this.options.currentDashboard.get('organization_id') === team.get('organization_id')
                && this.options.groupPermissionCollections[team.get('id')].canViewDashboard(Number(this.options.currentDashboard.get('id')))
        });
        var userGroupCollection = new UserGroupCollection(teams, {organizationId: this.options.currentOrganizationId});
        userGroupCollection.sort();
        this.$('.teams .panel-body > .row').empty().append(
            teamTable.renderCollectionList(userGroupCollection, teamTableProperties).$el
        );
    }
}

export class DashboardUserView extends BaseDashboardDetailView {

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/dashboards/' +
            this.options.currentDashboard.get('id') + '/users';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Users with access to this Dashboard', url: this.options.isOverview ? url : null},
            panelClass: 'users',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            if (!this.options.groupPermissionCollections[id]) {
                this.options.groupPermissionCollections[id] = new PermissionCollection([], {userGroupId: id});
            }
            return this.options.groupPermissionCollections[id].getCollectionFetchPromise();
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var usersTable = new BaseList(this.options);
        var usersTableProperties: TableProperties;
        usersTableProperties = {
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/users/',
            tableEmptyText: 'There are no Users with access',
            columnProperties: {
                'Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Email': {
                    attribute: 'email',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Phone Number': {
                    attribute: 'phone_number',
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Permissions': {
                    attribute: 'usergroups',
                    customColumn: {
                        templateFunction: _.template('<% var perms = []; %> ' +
                            ' <% _.each(mod.get("usergroups"), function(g, id) { %> ' +
                            ' <% var uGroup  = userGroupCollection.findWhere({id: Number(id)}) %>' +
                            ' <% if(groupPermissionCollections[uGroup.get("id")].canViewDashboard(dashboardId)) perms.push("View")%>' +
                            ' <% if(groupPermissionCollections[uGroup.get("id")].canModifyDashboard(dashboardId)) perms.push("Modify")%>' +
                            ' <% if(groupPermissionCollections[uGroup.get("id")].canDeleteDashboard(dashboardId)) perms.push("Delete")%>' +
                            ' <% }); %>' +
                            ' <div class="col-md-3 col-sm-2 col-xs-10 account-modify-team-member-since">' +
                            ' <%- _.uniq(perms).join(", ") %>' +
                            ' </div>'
                        ),
                        variables: {
                            userGroupCollection: this.options.userGroupCollection,
                            groupPermissionCollections: this.options.groupPermissionCollections,
                            dashboardId: Number(this.options.currentDashboard.get('id')),
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            usersTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var users = this.options.userCollection.filter((user) => {
            var canView = false;
            _.each(user.get('usergroups'), (uGroup, id) => {
                var dashboardId = Number(this.options.currentDashboard.get('id'));
                if (this.options.groupPermissionCollections[Number(id)].canViewDashboard(dashboardId)) {
                    canView = true;
                    return false;
                }
            });

            return canView;
        });
        var userCollection = new UserCollection(users, {organizationId: this.options.currentOrganizationId});
        this.$('.users .panel-body > .row').append(
            usersTable.renderCollectionList(userCollection, usersTableProperties).$el
        );
    }
}

export class DashboardInstallView extends BaseDashboardDetailView {

    private moduleCollections: { [installId: number]: ModuleCollection } = {};

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/dashboards/' +
            this.options.currentDashboard.get('id') + '/installs';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Installations used on this Dashboard', url: this.options.isOverview ? url : null},
            panelClass: 'installs',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    private getRelevantInstalls() {
        var viewableInstalls = _.uniq(_.flatten(this.options.userGroupCollection.map((g) => {
            return this.options.groupPermissionCollections[g.get('id')].getViewableInstallIds()
        })));

        var dashboardInstalls = _.uniq(this.options.dashboardChannelCollection.map((m) => {
            return m.get('install_id')
        }));
        return _.intersection(viewableInstalls, dashboardInstalls);
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            if (!this.options.groupPermissionCollections[id]) {
                this.options.groupPermissionCollections[id] = new PermissionCollection([], {userGroupId: id});
            }
            return this.options.groupPermissionCollections[id].getCollectionFetchPromise();
        });

        deferreds.push(this.options.dashboardChannelCollection.getCollectionFetchPromise());

        $.when.apply($, deferreds).then(() => {
            deferreds = _.map(this.getRelevantInstalls(), (installId) => {
                this.moduleCollections[installId] = new ModuleCollection([], {installId: installId});
                return this.moduleCollections[installId].fetch();
            });
            return $.when.apply($, deferreds)
        }).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var getInstallModifiedDate = function (install, modCols) {
            var dates = [moment(install.get('modified')).format("L")];
            var modDate = 0;
            modCols[install.get('id')].each((modCol) => {
                if (modCol.get('module_modified') > modDate) modDate = modCol.get('module_modified')
            });
            if (modDate !== 0) dates.push(moment.unix(modDate).format("L"));

            dates = _.sortBy(dates, (date) => {
                return date;
            }).reverse();

            return _.first(dates);
        };

        var installTable = new BaseList(this.options);
        var installTableProperties: TableProperties = {
            tableEmptyText: 'There are no Installations used on this Dashboard',
            columnProperties: {
                'Install Name': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-3 col-sm-3 col-xs-10">' +
                            ' <%- mod.getDisplayName() %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Address': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-2 col-sm-2 col-xs-10">' +
                            ' <%- mod.getDisplayAddress() ? mod.getDisplayAddress() : "" %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Gateway Serial Number': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Created': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("created") ? mod.get("created") : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center"><%- moment(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center">' +
                            ' ' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
                'Modified': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template(
                            '<% var inviteDate = getInstallModifiedDate(mod, modCols) %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center"><%- inviteDate ? inviteDate : "" %></div>'),
                        variables: {
                            moment: moment,
                            getInstallModifiedDate: getInstallModifiedDate,
                            modCols: this.moduleCollections
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            installTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var relevantInstalls = this.getRelevantInstalls();
        var installCollection = new InstallCollection(this.options.installCollection.filter((i) => {
            return _.includes(relevantInstalls, i.get('id'))
                && i.get('organization_id') === this.options.currentOrganizationId
        }));
        this.$('.installs .panel-body > .row').empty().append(
            installTable.renderCollectionList(installCollection, installTableProperties).$el
        );
    }
}

export class DashboardChannelView extends BaseDashboardDetailView {

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/dashboards/' +
            this.options.currentDashboard.get('id') + '/channels';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Channels on this Dashboard', url: this.options.isOverview ? url : null},
            panelClass: 'channels',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        $.when(this.options.dashboardChannelCollection.getCollectionFetchPromise()).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var dashboardChannelTable = new BaseList(this.options);
        var dashboardChannelTableProperties: TableProperties = {
            tableEmptyText: 'There are no Channels on this Dashboard',
            columnProperties: {
                'Name': {
                    attribute: 'dashboard_channel_name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Install': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-3 col-sm-3 col-xs-10">' +
                            ' <%- installCollection.findWhere({id: mod.get("install_id")}) ? installCollection.findWhere({id: mod.get("install_id")}).getDisplayName(): "" %>' +
                            ' </div>'),
                        variables: {
                            installCollection: this.options.installCollection
                        }
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Location': {
                    attribute: 'module_location',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Sensor': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-2 col-sm-2 col-xs-10">' +
                            ' <% if(mod.get("module_is_gateway")) { %>' +
                            ' <span class="badge">•</span>' +
                            ' <% } else { %>' +
                            ' <span class="badge">••••</span>' +
                            ' <% } %>' +
                            '  <%- " "+mod.get("sensor_name") %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Unit': {
                    centerColumn: true,
                    attribute: 'channel_unit',
                    columnSizes: {
                        'sm': '1',
                        'md': '1',
                        'xs': '12'
                    }
                },

            }
        };

        var channelCollection = new DashboardChannelCollection(this.options.dashboardChannelCollection.models);
        channelCollection.comparator = (model) => {
            return model.get('dashboard_channel_name');
        };
        channelCollection.sort();

        if (this.options.isOverview) {
            dashboardChannelTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'dashboard_channel_name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }
        this.$('.channels .panel-body > .row').empty().append(
            dashboardChannelTable.renderCollectionList(channelCollection, dashboardChannelTableProperties).$el
        );
    }
}

export class DashboardNotificationView extends BaseDashboardDetailView {

    private dashboardNotificationCollections: { [groupId: number]: DashboardNotificationCollection } = {};

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/dashboards/' +
            this.options.currentDashboard.get('id') + '/notifications';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Dashboard Notifications', url: this.options.isOverview ? url : null},
            panelClass: 'dashboard-notifications',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            this.dashboardNotificationCollections[id] = new DashboardNotificationCollection([], {userGroupId: id});
            return this.dashboardNotificationCollections[id].getCollectionFetchPromise();
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        })
    }

    showTable() {
        var notificationDashboardTable = new BaseList(this.options);
        var notificationDashboardTableProperties: TableProperties = {
            tableEmptyText: 'There are no Dashboard Notifications',
            columnProperties: {
                'Team': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var uId = mod.get("usergroup_id") %>' +
                            '<% var team = userGroupCollection.findWhere({id: uId}) %>' +
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell="<%- mod.get("enable_sms_notifications") ? "Enabled" : "Disabled" %>">' +
                            '<%- team.get("name") %>' +
                            '</div>'),
                        variables: {
                            userGroupCollection: this.options.userGroupCollection
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Number of channels': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template(
                            '<div class="col-md-2 col-sm-2 col-xs-10 text-center" data-table-cell="<%- mod.get("dashboard_channels").length %>">' +
                            '<%- mod.get("dashboard_channels").length %>' +
                            '</div>'),
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Interval': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var di = mod.get("digest_interval") %>' +
                            '<% var interval = "Immediately" %>' +
                            '<% if(di === 3600) { %>' +
                            '<% interval = "At most hourly"%>' +
                            '<% } %>' +
                            '<% if(di === 21600) { %>' +
                            '<% interval = "At most every 6 hours"%>' +
                            '<% } %>' +
                            '<% if(di === 43200) { %>' +
                            '<% interval = "At most every 12 hours"%>' +
                            '<% } %>' +
                            '<% if(di === 86400) { %>' +
                            '<% interval = "At most daily"%>' +
                            '<% } %>' +
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell=<%- interval %> >' +
                            '<%- interval %>' +
                            '</div>'),
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Enabled Notifications': {
                    customColumn: {
                        templateFunction: _.template(
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell="<%- mod.get("enable_email_notifications") ? "Enabled" : "Disabled" %>">' +
                            '<% notifs = [] %>' +
                            '<% mod.get("enable_email_notifications") ? notifs.push("Email") : "" %>' +
                            '<% mod.get("enable_sms_notifications") ? notifs.push("Text") : "" %>' +
                            '<%- notifs.join(", ") %>' +
                            '</div>'),
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Weekday Quiet Time': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var from = mod.get("quiet_time_weekday_start_seconds") %>' +
                            '<% var to = mod.get("quiet_time_weekday_end_seconds") %>' +
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell=<%- from %> >' +
                            '<%- from ?  moment.utc(from * 1000).format("h:mm A") + " to " : "" %> ' +
                            '<%- to ? moment.utc(to * 1000).format("h:mm A") : "" %>' +
                            '</div>'),
                        variables: {
                            moment: moment
                        },
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Weekend Quiet Time': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var from = mod.get("quiet_time_weekend_start_seconds") %>' +
                            '<% var to = mod.get("quiet_time_weekend_end_seconds") %>' +
                            '<div class="col-md-2 col-sm-2 col-xs-10" data-table-cell=<%- from %> >' +
                            '<%- from ? moment.utc(from * 1000).format("h:mm A") + " to " : "" %>' +
                            '<%- to ? moment.utc(to * 1000).format("h:mm A") : ""%>' +
                            '</div>'),
                        variables: {
                            moment: moment
                        },
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
            }
        };

        var notifs = [];
        _.each(this.dashboardNotificationCollections, (col: DashboardNotificationCollection) => {
            var dashNot = col.findWhere({dashboard_id: this.options.currentDashboard.get('id')});
            if (!dashNot) return;

            // Only include dashboard notification for which there are channels and either sms or email notifications are enabled
            if ((dashNot.get("enable_email_notifications") || dashNot.get("enable_sms_notifications"))
                && dashNot.get('dashboard_channels').length) {

                notifs.push(dashNot)
            }
        });
        var dashboardNotifications = new BaseCollection(_.uniq(notifs));

        if (this.options.isOverview) {

            notificationDashboardTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'enable_email_notifications',
                reverseSort: true,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        this.$('.dashboard-notifications .panel-body > .row').empty().append(
            notificationDashboardTable.renderCollectionList(
                dashboardNotifications, notificationDashboardTableProperties
            ).$el
        );
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/views/account/dashboards/DashboardDetailViews.ts